import styled from 'styled-components'

import { Body1 } from '@components/Text'

export default styled(Body1)`
  font-style: normal;
  font-weight: normal;
  line-height: 20px;
  color: ${props => props.color || 'var(--secondary-text);'}
  margin-top: 12px;
`
